import Footer from "@/components/landing/Footer";
import FloatingActions from "@/components/landing/FloatingActions";
import StickyMobileCTA from "@/components/landing/StickyMobileCTA";
import LoanNavbar from "@/components/loans/LoanNavbar";

export default function LoanLayout({ children, onCtaClick }) {
  return (
    <main className="min-h-screen bg-white">
      <LoanNavbar onCtaClick={onCtaClick} />

      <div className="pt-16 md:pt-20">{children}</div>

      <Footer />

      <FloatingActions />

      <StickyMobileCTA onCheckEligibility={onCtaClick} label="Free Consultation"/>

      <div className="md:hidden h-16" />
    </main>
  );
}
